<template >
  <div class="RoomGuestQuantity" v-if="show" :class="{ loading: loading > 0 }">
    <h2>{{ tran("ROOM_GUEST_QUANTITY_TITLE") }}</h2>
    <p>
      {{
        tran("ROOM_GUEST_QUANTITY_DESC", {
          maxGuest: run("get", "config.maxGuest"),
        })
      }}
    </p>
    <div
      class="category-unavailable"
      v-if="allRoomUnavailable"
      v-html="tran('ALL_CATEGORY_UNAVAILABLE')"
    ></div>
    <div class="number-of-guest items">
      <div class="item" v-for="index in data.numberOfRoom" :key="index">
        <div class="wrapper">
          <div
            class="category-unavailable"
            v-if="!allRoomUnavailable && errors[index - 1]"
            v-html="tran('ALL_CATEGORY_UNAVAILABLE')"
          ></div>
          <h4>
            <span v-html="tran('ROOM_INDEX', { room: index })"></span>
          </h4>
          <div class="room-quantity">
            <InputPlusField
              :required="true"
              v-model="data.rooms[index - 1].numberOfAdults"
              :min="run('get', 'config.minAdults')"
              :max="run('get', 'config.maxAdults')"
              :total="
                data.rooms[index - 1].numberOfAdults +
                data.rooms[index - 1].numberOfChildren
              "
              :minTotal="run('get', 'config.minGuest')"
              :maxTotal="run('get', 'config.maxGuest')"
              class="number-of-adults input-increase"
              :label="tran('ADULTS')"
              @input="changeQuantity"
            />
            <InputPlusField
              :required="true"
              v-model="data.rooms[index - 1].numberOfChildren"
              :min="run('get', 'config.minChildren')"
              :max="run('get', 'config.maxChildren')"
              :total="
                data.rooms[index - 1].numberOfAdults +
                data.rooms[index - 1].numberOfChildren
              "
              :minTotal="run('get', 'config.minGuest')"
              :maxTotal="run('get', 'config.maxGuest')"
              class="number-of-children input-increase"
              :label="tran('CHILDREN_UNDER_17')"
              @input="changeQuantity"
            />
          </div>
          <div
            @click.prevent="
              data.rooms[index - 1].wheelchair = data.rooms[index - 1]
                .wheelchair
                ? 0
                : 1
            "
            class="wheelchair input-checkbox"
            :class="{ checked: data.rooms[index - 1].wheelchair }"
          >
            <span class="fa fa-wheelchair"></span>
            <span v-html="tran('WHEELCHAIR_ACCESSIBLE')"></span>
          </div>
          <div
            v-if="run('get', 'config.senior', false)"
            @click.prevent="
              data.rooms[index - 1].senior = data.rooms[index - 1].senior
                ? 0
                : 1
            "
            class="senior input-checkbox"
            :class="{ checked: data.rooms[index - 1].senior }"
          >
            <span v-html="tran('AGE_55_OR_ABOVE')"></span>
          </div>
          <div class="room-offer">
            <span v-html="tran('SEE_IF_YOU_QUANLIFY_FOR_OFFER')"></span>
            <span class="fa fa-chevron-down"></span>
          </div>
        </div>
      </div>
    </div>

    <div class="buttons">
      <button
        id="guest-no-click"
        type="button"
        class="btn btn-success"
        :disabled="!run('validate')"
        @click.prevent="run('next')"
      >
        {{ tran("SELECT_CONTINUE") }}
      </button>
    </div>
  </div>
</template>

<script>
import InputPlusField from "./InputPlusField.vue";
export default {
  name: "RoomGuestQuantity",
  components: { InputPlusField },
  props: {
    run: Function,
  },
  data: function () {
    return {
      errors: {},
      loading: 0,
    };
  },
  mounted: function () {
    this.run("set", "groupStep." + this.$.type.name, "select_room");
    if (typeof this.validate == "function") {
      this.run("set", "validates." + this.$.type.name, this.validate);
    }
    if (typeof this.next == "function") {
      this.run("set", "nexts." + this.$.type.name, this.next);
    }
    if (typeof this.prev == "function") {
      this.run("set", "prevs." + this.$.type.name, this.prev);
    }
    if (this.show) {
      this.onShow();
    }
  },
  watch: {
    show: function (n) {
      if (n) {
        this.onShow();
      } else {
        this.onHide();
      }
    },
  },

  computed: {
    show: function () {
      return this.run("currentStep") == this.$.type.name;
    },
    data() {
      return this.run("get", "data");
    },
    rooms() {
      return this.run("rooms");
    },
    allRoomUnavailable() {
      if (this.rooms.length < 2) {
        return false;
      }
      for (const roomIndex in this.rooms) {
        if (!this.errors[roomIndex]) {
          return false;
        }
      }
      return true;
    },
  },
  methods: {
    tran: function (key, replaces) {
      return this.run("tran", key, replaces);
    },
    onShow() {},
    onHide() {
      this.errors = {};
    },
    changeQuantity() {
      this.run("repairRoom");
    },
    async next() {
      this.loading++;
      this.errors = {};
      const errors = {};
      const rooms = this.rooms;
      const numberOfRoom = this.run("numberOfRoom");
      const ship = this.run("get", "ship");
      let hasError = false;
      for (const roomIndex in rooms) {
        const room = rooms[roomIndex];
        const dataKey =
          "categoryData." +
          (room.numberOfAdults + "-" + room.numberOfChildren) +
          "-" +
          room.wheelchair +
          "-" +
          room.senior;
        let data = this.run("get", dataKey, false);
        if (!data || data.time < Date.now() - 30000) {
          const res = await this.run(
            "fetch",
            "index.php?option=com_cruise&task=" +
              this.run("get", "config.task", "booking") +
              ".getRoomCategories",
            {
              numberOfRoom,
              rooms,
              roomIndex,
              shipCode: ship.shipCode,
              packageId: ship.packageId,
              sailDate: ship.sailDate,
            }
          );
          if (!res.success) {
            this.run(
              "showMessage",
              res.message ?? "error",
              res.messageType,
              res.exitBooking,
              res.buttonLabel
            );
            this.loading--;
            return;
          }
          data = res.data;
          data.time = Date.now();
          this.run("set", dataKey, data);
        }
        let error = true;
        for (const item of data.items) {
          if (item.available) {
            error = false;
            break;
          }
        }
        if (error) {
          hasError = true;
        }
        errors[roomIndex] = error;
      }
      this.errors = errors;
      this.loading--;
      if (hasError) {
        return false;
      }
      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
